import { DefaultTheme } from 'styled-components';

import { TailwindFontSizeScale } from '@savgroup-front-common/types';

type FontStyleToken = keyof TailwindFontSizeScale;

/**
 * Applies a Tailwind text token as a styled-components fragment, setting the
 * matching `font-size` and paired `line-height` at once through the
 * `theme.tw.font` namespace.
 *
 * Usage: `${fontStyle('base')}` inside a styled template.
 */
export const fontStyle =
  (token: FontStyleToken) =>
  ({ theme }: { theme: DefaultTheme }): string =>
    `font-size: ${theme.tw.font.size[token]}; line-height: ${theme.tw.font.lineHeight[token]};`;
